<template>
  <ui-dialog
    :show="isOpen"
    :title="$t('message.gmbVerification.dialog.title').toString()"
    :closable="false"
    persistent
    scrollable
    custom-class="gmb-verification-dialog"
    @input="close"
  >
    <p>{{ $t("message.gmbVerification.dialog.body", { fields: labels }) }}</p>

    <div
      class="changes-section"
      v-for="field in verificationFields"
      :key="field"
    >
      <strong
        >{{ $t(`message.gmbVerification.changes.${field}.label`) }}:</strong
      >
      <p>{{ $t(`message.gmbVerification.changes.${field}.description`) }}</p>
      <a
        :href="GMB_VERIFICATION_INFO_LINKS[field]($i18n.locale)"
        target="_blank"
        >{{ $t(`message.common.moreInformations`) }}</a
      >
    </div>

    <p>{{ $t("message.gmbVerification.dialog.confirm") }}</p>
    <template #actions>
      <ui-button outlined @click="cancel">
        {{ $t("message.common.cancel") }}
      </ui-button>
      <ui-button color="primary" @click="confirm">
        {{ $t("message.common.save") }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
import {
  GMB_CHANGE_FIELD_TYPE,
  GMB_VERIFICATION_INFO_LINKS
} from "@/helpers/mixins/gmb-update-verification";

export default {
  name: "GmbVerificationDialog",
  props: {
    verificationFields: {
      type: Array,
      required: true,
      validate: value => Object.values(GMB_CHANGE_FIELD_TYPE).includes(value)
    }
  },
  data() {
    return {
      isOpen: false,
      GMB_VERIFICATION_INFO_LINKS
    };
  },
  computed: {
    labels() {
      return this.verificationFields
        .map(i =>
          this.$t(`message.gmbVerification.changes.${i}.label`)
            .toString()
            .toLowerCase()
        )
        .join(", ");
    }
  },
  mounted() {
    this.isOpen = true;
  },
  methods: {
    close() {
      this.isOpen = false;
      this.$emit("close");
      setTimeout(() => {
        this.$destroy();
      }, 200);
    },
    confirm() {
      this.$emit("confirm");
      this.close();
    },
    cancel() {
      this.$emit("cancel");
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.gmb-verification-dialog {
  p {
    white-space: pre-line;
    margin-bottom: 0;
  }
  .changes-section {
    margin: $spacing * 2.5 0;
  }
}
</style>
